// Canonical CAD input; avoid floating-point balance comparisons in write requests.
export function positiveMoney(value) {
  const text = String(value).trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) {
    throw new Error('Enter an amount with at most two decimal places.');
  }
  const [whole, fraction = ''] = text.split('.');
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (!Number.isSafeInteger(cents) || cents <= 0 || cents > 9999999999) {
    throw new Error('Enter an amount between $0.01 and $99,999,999.99.');
  }
  return (cents / 100).toFixed(2);
}
